const SET_USER_SUBSCRIPTION = 'SET_USER_SUBSCRIPTION';

export const subscriptionReducer = (state = null, action) => (action.type === SET_USER_SUBSCRIPTION ? action.payload : state);

export const setSubscription = (subscription) => ({
  type: SET_USER_SUBSCRIPTION,
  payload: subscription,
});
